"use client";
import { useEffect } from "react";

export function ViewTracker({ slug }: { slug: string }) {
  useEffect(() => {
    const key = `viewed_svc_${slug}`;
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, "1");
    fetch(`/api/services/${slug}/view`, { method: "POST" }).catch(() => {});
  }, [slug]);
  return null;
}
